import { Pipe, PipeTransform } from '@angular/core';
import { MissionRequest } from '../../models/mission/mission-request';

@Pipe({
	name: 'filterFormationByDate'
})
export class FilterFormationsByDatePipe implements PipeTransform {
	transform(formations: MissionRequest[], dateFilter: Date): MissionRequest[] {
		if (!dateFilter || !formations) {
			return formations;
		}

		return formations.filter((missionRequest) => {
			if (missionRequest.date !== null) {
				return new Date(missionRequest.date).getDate() === dateFilter.getDate();
			}
			return false;
		});
	}
}
